import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';

import type { QueryConfig } from '@/lib/react-query';
import { api, extractData } from '@/lib/treaty';

export type Project = NonNullable<
  Awaited<ReturnType<ReturnType<typeof api.projects>['get']>>['data']
>;

type ProjectQueryOptions = {
  queryConfig?: QueryConfig<typeof getProject>;
  id: Project['id'];
};

export const getProject = (id: Project['id']) => {
  return extractData(api.projects({ id: id }).get());
};

export const getProjectOptions = (id: Project['id']) => ({
  queryKey: ['project', id],
  queryFn: () => getProject(id),
});

export const getProjectQueryOptions = (id: Project['id']) => {
  return queryOptions(getProjectOptions(id));
};

export const useProject = ({ queryConfig, id }: ProjectQueryOptions) => {
  return useSuspenseQuery({ ...queryConfig, ...getProjectQueryOptions(id) });
};

type ProjectsQueryOptions = Parameters<typeof api.projects.get>[number];
export type Projects = Awaited<ReturnType<typeof getProjects>>;

export const getProjects = (args?: ProjectsQueryOptions) => {
  return extractData(
    api.projects.get({
      ...args,
      query: args?.query || {},
    })
  );
};

export const getProjectsQueryOptions = (args?: ProjectsQueryOptions) => {
  return queryOptions({
    queryKey: ['projects', args],
    queryFn: () => getProjects(args),
  });
};

export const useProjects = (args?: ProjectsQueryOptions) => {
  return useSuspenseQuery({ ...getProjectsQueryOptions(args) });
};
